var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectOption'),_c('grid-manager',{ref:"grid",attrs:{"option":_vm.gridOption}}),_c('div',{staticClass:"tip-text"},[_vm._v("当前界面数据实时更新")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }